import payroll from './pages'
import PayrollMenu from './pages/PayrollMenu.vue'
import salaryAdvances from './pages/SalaryAdvances.vue';
import requestSalaryAdvances from './pages/RequestSalaryAdvance.vue';

const router = {
  name: 'payroll',
  path: '/payroll',
  component: payroll,
  children: [
    {
      path: '/payroll-menu',
      name: 'payroll-menu',
      component: PayrollMenu,
      meta: {
        showMenu: false,
        requiresAuth: true,
        requiresPermission: true,
        action: 'payroll',
        titleHeader: 'Nomina'
      },
    },
    {
      path: '/salary-advances',
      name: 'salaryAdvances',
      component: salaryAdvances,
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        action: 'payroll',
        titleHeader: 'Anticipos de sueldos'
      }
    },
    {
      path: '/request-salary',
      name: 'requestSalaryAdvances',
      component: requestSalaryAdvances,
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        action: 'payroll',
        titleHeader: 'Anticipos de sueldos'
      }
    }
  ]
}

export default router